import React from 'react';
import { Currency, DateTime } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, currency, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ projectExpense }) => (
    <>
      <DateTime value={projectExpense.date} /> &middot; {projectExpense.expenseCategory?.name} &middot;{' '}
      <Currency value={projectExpense.amount} currency={currency} />
    </>
  );

  return (
    <BulkActionModal
      title="Delete Project Expenses"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .projectExpenses()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete ${
        ids.length === 1 ? 'the selected project expense' : `the ${ids.length} selected project expenses`
      }. Invoiced expenses will be skipped. This action cannot be undone.`}
    </BulkActionModal>
  );
}
